import type { ReactElement } from "react"
import CtaElement from "@gatsby-plugin-generic-page/components/CtaElement"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import Media from "@gatsby-plugin-generic-page/components/Media"
import type { MediaCardFlatData } from "@gatsby-plugin-generic-page/fragments/mediaCard"
import { CardMedia, Text } from "@ionos-web-design-system/react"
import isEmpty from "~/lib/isEmpty"

type MediaCardProps = {
  card: MediaCardFlatData
}

function MediaCard({ card }: MediaCardProps): ReactElement<MediaCardProps> {
  return (
    <CardMedia
      media={
        card.responsiveImages ? (
          <Media media={card.responsiveImages} />
        ) : undefined
      }
      alignment="middle"
      reverse
      className="bg-surface-subtle p-3 rounded-sm flex-1"
    >
      <div className="p-3 pr-0">
        {card.caption ? (
          <Text
            variant="bodyMd"
            color="base"
            className="uppercase mb-2"
            asChild
          >
            <h5>{card.caption}</h5>
          </Text>
        ) : null}

        <Text variant="headingXl" color="base" weight="bold" asChild>
          <h3>{card.title}</h3>
        </Text>

        {card.description ? (
          <div className="mt-4">
            <MarkdownText>{card.description}</MarkdownText>
          </div>
        ) : null}

        {!isEmpty(card.button) && (
          <div className="mt-3">
            <CtaElement ctaElement={card.button} />
          </div>
        )}
      </div>
    </CardMedia>
  )
}

export default MediaCard
